import { EAgentTypes } from '../enums/EAgentTypes';
import { WORK_HONESTLY_MESSAGES } from '../mappers/WORK_HONESTLY_MESSAGES';

export function getProofMessage(type: EAgentTypes) {
  return WORK_HONESTLY_MESSAGES[type];
}
